@import "../../global/normalize.css";

:host {
  display: block;

  --footer-compliance-padding: 1rem 0;
}

:host(.ic-footer-sparse) {
  --footer-links-padding: 1.5rem 0;
  --footer-logo-margin-bottom: calc(var(--ic-space-md) + var(--ic-space-xxs));
  --footer-link-inner-flex-direction: row;
}

:host(.ic-footer-small) {
  --footer-links-padding: 0 0;
  --footer-logo-margin-bottom: var(--ic-space-md);
  --footer-link-inner-flex-direction: column;
}

:host(.ic-footer-foreground-dark) {
  --ic-footer-background: var(--ic-brand-color-secondary-light);
  --ic-footer-bottom-background: var(--ic-brand-color-tertiary-light);
  --ic-footer-keyline: var(--ic-state-layer-darken-20);
  --ic-footer-text: var(--ic-color-text-primary-light);
  --ic-footer-link: var(--ic-color-text-primary-light);
  --ic-footer-icon: var(--ic-color-icon-neutral);
  --ic-footer-chevron-icon: var(--ic-color-icon-neutral);
  --ic-footer-logo: var(--ic-color-icon-neutral);
  --ic-footer-hover: var(--ic-architectural-700-state-layer-10);
  --ic-footer-pressed: var(--ic-architectural-700-state-layer-20);
}

:host(.ic-footer-small.ic-footer-ungrouped) {
  --footer-links-padding: var(--ic-space-md) 0 0 0;
}

/* Main inner footer element */
footer {
  display: flex;
  flex-direction: column;
  width: 100%;
}

/* Description */

.footer-description {
  background-color: var(--ic-footer-background);
  color: var(--ic-footer-text);

  --ic-typography-color: var(--ic-footer-text);

  border-bottom: var(--ic-space-1px) solid var(--ic-footer-keyline);
}

.footer-description-inner {
  padding: 1rem 0;
}

/* Links */

.footer-links {
  padding: var(--footer-links-padding);
  background-color: var(--ic-footer-background);
  color: var(--ic-footer-link);

  --ic-typography-color: var(--ic-footer-link);
}

.footer-links-inner {
  display: flex;
  flex-direction: var(--footer-link-inner-flex-direction);
}

/* Compliance */

.footer-compliance {
  background-color: var(--ic-footer-bottom-background);
  color: var(--ic-footer-text);

  --ic-typography-color: var(--ic-footer-text);
}

.footer-compliance-inner {
  padding: var(--footer-compliance-padding);
}

.footer-logo {
  margin-bottom: var(--footer-logo-margin-bottom);
  display: flex;
  gap: var(--ic-space-xxl);
}

.footer-logo > ::slotted() {
  margin-right: var(--ic-space-md);
}

.footer-caption {
  margin-bottom: var(--ic-space-md);
}

.classification-spacing {
  margin-bottom: var(--ic-space-lg);
}

@media (forced-colors: active) {
  footer {
    border-top: var(--ic-border-hc);
  }
}
